import { createParser, parseAsArrayOf, parseAsString } from 'nuqs/server'

const rangeFilterParser = createParser({
  serialize: (value: { min: number; max: number } | null | undefined): string => {
    if (!value) return ''
    return `${value.min},${value.max}`
  },
  parse: (
    value: string | (string | null)[] | null | undefined
  ): { min: number; max: number } | undefined => {
    if (!value || typeof value !== 'string') return undefined
    const [min, max] = value.split(',').map(Number)
    if (Number.isNaN(min) || Number.isNaN(max)) return undefined
    return { min, max }
  },
})

const multiParser = parseAsArrayOf(parseAsString)

export const filterParsers = {
  accommodationType: multiParser.withDefault([]),
  facility: multiParser.withDefault([]),
  suitableFor: multiParser.withDefault([]),
  activity: multiParser.withDefault([]),
  price: rangeFilterParser,
  category: multiParser.withDefault([]),
}
